module.exports = __webpack_public_path__ + "img/1-3.172ee519.jpg";